import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Text } from "north.js";
import React, { useState } from "react";
import styled from "styled-components";

interface ShiftSectionProps {
  title: string;
  count: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const ShiftSection: React.FC<ShiftSectionProps> = ({
  title,
  count,
  defaultOpen = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Section>
      <SectionHeader
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <ChevronDownIcon width="16px" height="16px" />
        ) : (
          <ChevronRightIcon width="16px" height="16px" />
        )}
        <Text type="h3">
          {title} ({count})
        </Text>
      </SectionHeader>
      {isOpen && (
        <SectionBody>
          {count === 0 ? (
            <EmptyRow type="body2">No shifts here.</EmptyRow>
          ) : (
            children
          )}
        </SectionBody>
      )}
    </Section>
  );
};

const Section = styled.div`
  margin-bottom: 16px;
`;

const SectionHeader = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
`;

const SectionBody = styled.div`
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
  border-radius: 8px;
  overflow: hidden;
`;

const EmptyRow = styled(Text)`
  display: block;
  padding: 12px 16px;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
`;

export default ShiftSection;
